import { size } from "lodash";
import React from "react";
import { useState, useEffect } from "react";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Etiqueta } from "../pages/etiquetas/etiqueta";

//Recibe un areglo con hasta 80 elementos y genera una lista de etieuetas
const HojaEtiquetas = (props) => {
    var medidas = { ancho: 0, alto: 0, etiqW: 0, etiqH: 0, anchoInterno: 0, anchoExterno: 0, espVertical: 0 };
    medidas.alto = 1200;
    medidas.ancho = medidas.alto * 0.7727272727272727;
    medidas.etiqH = medidas.alto * .0454545454545;
    medidas.etiqW = medidas.alto * 0.1590909090909091;
    medidas.anchoInterno = medidas.alto * 0.0286327845382963;
    medidas.anchoExterno = medidas.alto * 0.0250536864710093;
    medidas.espVertical = medidas.alto * 0.0429491768074445;
    console.log(props.etiquetas);
    var etiqueta = { width: `${medidas.etiqW}px`, height: `${medidas.ancho / medidas.etiqW}px` };

    var etq = [];
    let hoja = [];
    let etiquetas = props.etiquetas ?? [];
    for (let i = 0; i < etiquetas.length; i += 4) {
        let slice = etiquetas.slice(i, i + 4);
        if (hoja.length < 20) hoja.push(slice);
        else {
            etq.push(hoja);
            hoja = [slice];
        }
    }
    etq.push(hoja);

    var counter = 36524;

    const getKey = () => {
        counter++;
        return counter;
    }
    //84666
    //.634999

    const createPDF = async (hoja) => {
        if (props.loader) props.loader(true);

        const
            componentRef = document.getElementById(`hojaX${hoja}`); // Reemplaza con el ID de tu componente
        const canvas = await html2canvas(componentRef, { scale: 2.2 });

        // Calcula el ancho y el alto de la imagen en el PDF
        const imgWidth = 215.9; // Ancho de la página en mm (A4)
        const imgHeight = 279.4;
        // Crea el documento PDF con el tamaño adecuado
        const doc = new jsPDF({
            orientation: 'portrait', // 'portrait' para retrato, 'landscape' para apaisado
            unit: 'mm',
            format: [215.9, 279.4], // [ancho, alto]
            //margin: { top: 0, right: 0, bottom: 0, left: 0 },
        });

        // Agrega la imagen al PDF sin bordes
        doc.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, imgWidth, imgHeight);

        // Guarda el PDF
        doc.save(`etiq-semana_${etq[0][0][0].semana}-dia_${etq[0][0][0].dia}-hoja_${hoja + 1}`);
        if (props.loader) props.loader(false);
    };


    return (
        <div className='row justify-content-center rounded' >
            {etq.map((hoja, i) => {
                return (
                    <>
                        <div className='col-lg-12 text-center pt-5'>
                            <button className='btn btn-light btn-sm shadow text-bold text-floricents' onClick={() => { createPDF(i) }}>Descargar hoja {i + 1}</button>
                        </div>
                        <div className='col-lg-12 m-0 border bg-white pb-1'
                            id={"hojaX" + i}
                            style={{
                                width: `${medidas.ancho}px`,
                                height: `${medidas.alto}px`,
                                minWidth: `${medidas.ancho}px`,
                                paddingTop: `${medidas.espVertical}px`,
                                paddingBottom: `${medidas.espVertical}px`,
                                paddingLeft: `${medidas.anchoExterno}px`,
                                paddingRight: `${medidas.anchoExterno}px`

                            }}
                            key={getKey() + "hoja"}>

                            <div className='row justify-content-center p-0 m-0 '>
                                {
                                    hoja.map((renglon, j) => {
                                        return (
                                            <div key={getKey() + 'wefwer'} className='row justify-content-bewtween  m-0 p-0'
                                                style={{
                                                    width: `${medidas.ancho - (medidas.anchoExterno * 2)}px`,
                                                    minWidth: `${medidas.ancho - (medidas.anchoExterno * 2)}px`,
                                                }}>
                                                {
                                                    renglon.map((etq, j) => {
                                                        return (
                                                            <Etiqueta sizes={{ width: medidas.etiqW, height: medidas.etiqH }}
                                                                keys={getKey()}
                                                                index={j}
                                                                interno={medidas.anchoInterno}
                                                                externo={medidas.anchoExterno}
                                                                data={etq} />)
                                                    })
                                                }
                                            </div>

                                        )


                                    })
                                }

                            </div>
                        </div>
                    </>
                )
            })}

        </div>
    );
}

export default HojaEtiquetas;
